import { TfiClose } from "react-icons/tfi";

// CRN Schema Modal Component
const CRNSchemaModal = ({ isOpen, onClose, item }) => {
    if (!isOpen || !item) return null;

    // Convert item object to key-value pairs, excluding null/undefined and internal fields like 'id'
    const schemaData = Object.entries(item)
        .filter(([key, value]) => value != null && key !== 'id')
        .map(([key, value]) => ({
            key: key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1').trim(),
            value: String(value).trim() || '-',
        }));

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-2xl max-h-[80vh] overflow-y-auto">
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-xl font-semibold text-gray-900">CRN Schema Details</h3>
                    <button onClick={onClose} className="text-gray-600 hover:text-gray-800" title="Close">
                        <TfiClose className="text-gray-900 font-extrabold" size={28} />
                    </button>
                </div>
                <table className="w-full border-collapse">
                    <thead>
                        <tr className="bg-gray-100">
                            <th className="border border-gray-300 px-4 py-2 text-left text-xl font-extrabold text-gray-900">Field</th>
                            <th className="border border-gray-300 px-4 py-2 text-left text-xl font-extrabold text-gray-900">Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        {schemaData.map(({ key, value }, index) => (
                            <tr key={index} className="hover:bg-gray-50">
                                <td className="border border-gray-300 px-4 py-2 text-lg text-gray-900 font-bold">{key}</td>
                                <td className="border border-gray-300 px-4 py-2 text-lg text-gray-900 break-words">{value}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div className="flex justify-end mt-4">
                    <button
                        onClick={onClose}
                        className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 rounded-md shadow"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CRNSchemaModal